import { DEFAULT_SORT } from "src/constants/common";
export const initialState = {
  resultsData: {},
  filterResults: {},
  showSeatLayout: false,
  filterList: {
    sortBy: [
      { id: 1, title: "Top rated", value: "top_rated", selected: true },
      { id: 2, title: "Cheapest", value: "cheapest", selected: false },
      {
        id: 3,
        title: "Late departure",
        value: "late_departure",
        selected: false,
      },
      {
        id: 4,
        title: "Early departure",
        value: "early_departure",
        selected: false,
      },
    ],
    departure: [
      {
        id: 1,
        title: "Early morning",
        value: { start: "0", end: "6" },
        description: "12AM - 6AM",
        selected: false,
      },
      {
        id: 2,
        title: "Morning",
        value: { start: "6", end: "12" },
        description: "6AM - 12PM",
        selected: false,
      },
      {
        id: 3,
        title: "Afternoon",
        value: { start: "12", end: "18" },
        description: "12PM - 6PM",
        selected: false,
      },
      {
        id: 4,
        title: "Night",
        value: { start: "18", end: "24" },
        description: "6PM - 12AM",
        selected: false,
      },
    ],
    busType: [
      {
        id: 1,
        title: "AC",
        value: "hasAc",
        selected: false,
      },
      {
        id: 2,
        title: "Non-AC",
        value: "non_ac",
        selected: false,
      },
      {
        id: 3,
        title: "Seater",
        value: "isSeater",
        selected: false,
      },
      {
        id: 4,
        title: "Sleeper",
        value: "isSleeper",
        selected: false,
      },
    ],
    starRating: [
      {
        id: 1,
        title: "5",
        value: 5,
        selected: false,
      },
      {
        id: 2,
        title: "4 & above",
        value: 4,
        selected: false,
      },
      {
        id: 3,
        title: "3 & above",
        value: 3,
        selected: false,
      },
    ],
    amenities: [],
    pickupPoints: [],
    dropOffPoints: [],
    busOperators: [],
  },

  selectedFilters: {
    sortBy: [DEFAULT_SORT],
    departure: [],
    busType: [],
    amenities: [],
    starRating: [],
    pickupPoints: [],
    dropOffPoints: [],
    busOperators: [],
  },
  showFilters: false,
  noResultsFound: {
    type: {
      TYPE: "",
      TITLE: "",
      MESSAGE: "",
    },
    value: false,
  },
  govtBuses: {},
  filteredGovtBuses: {},
  resultsLoading: true,
};
